<template>
    <div :class="[base ? 'pichi-tunnel-ball-info' : 'ballInfoMain-compar']">
        <div class="ballInfoMain">
            <!-- <div :class="[base ? 'ballInfoMain' : 'ballInfoMain-compar']"> -->
            <!-- <p>{{ gameDate }}</p> -->
            <div
                v-if="savedStandardBall.length > 0 && savedStandardBall[0]"
                class="pitcher"
            >
                <p class="Classification">
                    {{ base ? '【投球1】' : '【投球2】' }}
                </p>
                <p class="team">
                    {{ savedStandardBall[0].team.name }}
                </p>
                <p class="player">
                    <span class="no">{{ savedStandardBall[0].pitcher.uniform_number }}</span><span
                        class="name"
                    >{{ savedStandardBall[0].pitcher.name }}</span>
                </p>
            </div>
            <div
                v-else
                class="attention"
            >
                <p class="text">
                    投球{{ base ? '1' : '2' }}を設定してください
                </p>
            </div>
            <div
                v-if="savedStandardBall.length > 0 && savedStandardBall[0]"
                class="infoWrapper ball"
            >
                <table class="info">
                    <tr>
                        <td class="item">
                            試合日
                        </td>
                        <td class="value">
                            {{ playGameDate }}
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            球場名
                        </td>
                        <td class="value">
                            {{ playGameStadium }}
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            球種
                        </td>
                        <td class="value">
                            {{ setting.typesOfBall[savedStandardBall[0].data.pitchingdata.TaggedPitchType].name }}
                        </td>
                    </tr>
                </table>
                <div class="expand">
                    <table class="info">
                        <tr>
                            <td class="item">
                                対戦チーム
                            </td>
                            <td class="value">
                                {{ savedStandardBall[0].vsTeam.name }}
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                速度
                            </td>
                            <td class="value">
                                {{ (Math.round(savedStandardBall[0].data.pitchingdata.RelSpeed / 100)) / 10 }}km/h
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                回転速度
                            </td>
                            <td class="value">
                                {{
                                    Math.round(savedStandardBall[0].data.pitchingdata.SpinRate * 10) / 10
                                }}rpm
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                α
                            </td>
                            <td class="value">
                                {{
                                    Math.round(savedStandardBall[0].data.pitchingdata.Rifle * 10) / 10
                                }}°
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                速度割合
                            </td>
                            <td class="value">
                                {{ savedStandardBall[0].data.pitchingdata.avgSpeed }}
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                変化量縦
                            </td>
                            <td class="value">
                                {{
                                    (Math.round(savedStandardBall[0].data.pitchingdata.InducedVertBreak * 1000) / 10)
                                }}cm
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                変化量横
                            </td>
                            <td class="value">
                                {{ (Math.round(savedStandardBall[0].data.pitchingdata.HorzBreak * 1000) / 10) }}cm
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                奥行
                            </td>
                            <td class="value">
                                {{ (Math.round(savedStandardBall[0].data.pitchingdata.Depth * 1000) / 10) }}cm
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                リリース高
                            </td>
                            <td class="value">
                                {{ (Math.round(savedStandardBall[0].data.pitchingdata.RelHeight * 1000) / 10) }}cm
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                リリース横
                            </td>
                            <td class="value">
                                {{ (Math.round(savedStandardBall[0].data.pitchingdata.RelSide * 1000) / 10) }}cm
                            </td>
                        </tr>
                        <tr>
                            <td class="item">
                                エクステンション
                            </td>
                            <td class="value">
                                {{ (Math.round(savedStandardBall[0].data.pitchingdata.Extension * 1000) / 10) }}cm
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="icon-wrapper">
                    <v-touch
                        v-if="savedStandardBall.length > 0 && savedStandardBall[0]"
                        tag="p"
                        class="openSearchBtn"
                        @tap="movePT2Search"
                    >
                        <span class="icon-search" />
                    </v-touch>


                    <v-touch
                        v-if="!savedStandardBall[0].compareExist"
                        tag="button"
                        class="add-compare"
                        @tap="addBaseBall"
                    >
                        比較
                    </v-touch>

                    <v-touch
                        v-if="savedStandardBall[0].compareExist"
                        tag="button"
                        class="add-compare done"
                        @tap="removeBaseBall"
                    >
                        済
                    </v-touch>

                    <!--
                    <v-touch tag="button" class="pt-disable done" v-if="savedStandardBall[0].ptFlag"
                             @tap="setSavedStandardBallPTFlag">
                      PT済
                    </v-touch>
                    <v-touch tag="button" class="pt-disable" v-else @tap="setSavedStandardBallPTFlag">
                      PT
                    </v-touch>
                    -->

                    <!-- ボールカラー -->
                    <svg
                        v-if="savedStandardBall.length > 0 && savedStandardBall[0]"
                        class="ballColor"
                    >
                        <circle
                            cx="12"
                            cy="13"
                            r="6"
                            :fill="savedStandardBall[0].ballColor"
                        />
                    </svg>
                    <!-- 有効化 無効化 -->
                    <v-touch
                        v-if="(savedStandardBall.length > 0 && savedStandardBall[0]) && savedStandardBall[0].enabled"
                        tag="p"
                        class="view enable"
                        @tap="toggleSavedStandardBall(false)"
                    >
                        <span class="icon-view" />
                    </v-touch>
                    <v-touch
                        v-else-if="(savedStandardBall.length > 0 && savedStandardBall[0]) && !savedStandardBall[0].enabled"
                        tag="p"
                        class="view disable"
                        @tap="toggleSavedStandardBall(true)"
                    >
                        <span class="icon-view" />
                    </v-touch>

                    <!-- 開閉ボタン -->
                    <v-touch
                        v-if="opened === true && savedStandardBall.length > 0 && savedStandardBall[0]"
                        tag="p"
                        class="triangle"
                        @tap="close"
                    >
                        <span
                            class="icon-arrow-up"
                        />
                    </v-touch>
                    <v-touch
                        v-else-if="opened === false && savedStandardBall.length > 0 && savedStandardBall[0]"
                        tag="p"
                        class="triangle"
                        @tap="open"
                    >
                        <span
                            class="icon-arrow-down"
                        />
                    </v-touch>
                    <!-- </v-touch> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery"
import setting from "@/setting.js"
import common from "@/common.js"
import {mapGetters} from "vuex"

export default {
    props: [
        "savedBalls",
        "savedStandardBall",
        "base",
        "compar"
    ],
    emits: ['compare-exist-check', 'set-pichi-tunnel-saved-standard-ball', 'get-saved-balls', 'move-pt-2-search', 'close-pitcher-panel', 'toggle-saved-standard-ball', 'set-saved-standard-ball-ptflag'],
    data() {
        return {
            setting: setting,
            opened: true,
            sessionBaseKey: setting.sessionKey.pichiTunnelBase, // ピッチトンネルセッションストレージ基準球キー名
            sessionCompareKey: setting.sessionKey.pichiTunnelCompar // ピッチトンネルセッションストレージ比較球キー名
        }
    },
    computed: {
        ...mapGetters(['listOfStadiums']),
        playGameDate: function () {
            return this.$d(this.savedStandardBall[0].data.pitchingdata.Date).format("YYYY/MM/DD")
        },
        playGameStadium: function () {
            return (this.savedStandardBall[0].data.pitchingdata.Stadium)
                ? this.listOfStadiums[this.savedStandardBall[0].data.pitchingdata.Stadium].additional.name_short
                : ''
        },
        addBallMassage: function () {
            return this.base
                ? "比較モードの基準球を入れ替え"
                : "比較モードの比較球に追加"
        }
    },
    updated () {
        console.log('updated')
        const target = document.querySelector('#app > div > div > div.flex > div > div.pichiTunnelBallInfo > div.pichi-tunnel-ball-info > div > div.infoWrapper.ball > div.icon-wrapper > button.add-compare')
        //target.addEventListener('click', this.addBaseBall)
    },
    methods: {
        open (event) {
            console.log("opens")
            this.opened = true
            const className = this.base ? ".base-info" : ".compar-info"
            // $(className).css("max-height", "525px");
            $(event.target).closest('.ball').addClass('open')
            $(event.target).closest('.ball').children('.expand').css('max-height', '800px')
            $(event.target).closest('.ball').children('.expand').children('.info').fadeIn()
        },
        close (event) {
            console.log("close")
            this.opened = false
            const className = this.base ? ".base-info" : ".compar-info"
            // $(className).css("max-height", "525px");
            $(event.target).closest('.ball').removeClass('open')
            $(event.target).closest('.ball').children('.expand').css('max-height', '0')
            $(event.target).closest('.ball').children('.expand').children('.info').fadeOut()
        },
        saveBall () {
            if (this.base) {
                this.addBaseBall()
            } else {
                this.addSavedBalls()
            }
        },
        addBaseBall () {
            this.$ls.set('savedStandardBalls', this.savedStandardBall)
            this.$alert('比較モードの基準球に上書き登録しました')
            this.$emit('compare-exist-check')
            this.$emit('set-pichi-tunnel-saved-standard-ball')
            common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '投球1 基準球設定', this.savedStandardBall[0].id)
        },
        removeBaseBall () {
            this.$ls.set('savedStandardBalls', [])
            this.$alert('比較モードの基準球を削除しました')
            this.$emit('compare-exist-check')
            this.$emit('set-pichi-tunnel-saved-standard-ball')
            common.LOG('INFO', '3D軌跡 ピッチトンネル トップ', '投球1 基準球削除', this.savedStandardBall[0].id)
        },
        addSavedBalls () {
            let duplicate = false
            let data = this.savedStandardBall[0]
            let savedBalls = this.$ls.get("savedBalls")
            if (savedBalls.length >= 20) {
                this.messageModalOn("比較球が20球登録されています。")
                return
            }
            savedBalls.forEach(function (d, i) {
                if (d.data.id === data.data.id) {
                    duplicate = true
                }
            })
            if (duplicate) {
                this.$alert("すでに登録済みの投球です。")
            } else {
                data = savedBalls.concat(data)
                this.$ls.set("savedBalls", data)
                this.getSavedBalls()
                this.$alert("投球を比較リストに追加しました。")
            }
        },
        getSavedBalls: function () {
            this.$emit("get-saved-balls")
        },
        getResultText: function (result, hit) {
            let text = ""
            if (result === "Undefined" && hit === "Undefined") {
                return "-"
            }
            if (result === "InPlay") {
                text = this.setting.typesOfResult["InPlay"][hit].name
            } else {
                text = this.setting.typesOfResult[result].name
            }
            return text
        },
        invalidPinch: function (e) {
            e.preventDefault()
        },
        movePT2Search: function () {
            this.$emit('move-pt-2-search')
        },
        toggleSavedStandardBall: function (bool) {
            const target = this.base ? 'savedStandardBall' : 'savedBalls'
            this.$emit("toggle-saved-standard-ball", bool, 0, target)
        },
        messageModalOn: function (msg) {
            this.$root.$emit("messageModalOn", msg)
        },
        closePitcherPanel: function () {
            this.$emit("close-pitcher-panel")
        },
        blurAfter () {
            $("body").scrollTop(0)
        },
        setSavedStandardBallPTFlag () {
            console.log('this.savedStandardBall[0].ptFlag' + this.savedStandardBall[0].ptFlag)
            this.$emit('set-saved-standard-ball-ptflag', 0, !this.savedStandardBall[0].ptFlag)
        }
    }
}
</script>

<style scoped>
.pichi-tunnel-ball-info {
    position: absolute;
    top: 55px;
    right: 84px;
}

.ballInfoMain-compar {
    position: absolute;
    top: 55px;
}

.ball-finfo-compar {
    position: absolute;
    top: 55px;
}

.ballInfoMain {
    color: #fff;
    width: 250px;
    background: rgba(51, 51, 51, 0.95);
    padding-bottom: 30px;
    position: relative;
}

.ball .expand {
    transition: .2s;
}

.ball .expand .info {
    margin-top: 0;
}

.attention {
    padding: 15px 15px 2px;
    font-size: 15px;
    line-height: 15px;
}

.pitcher {
    padding: 15px;
    font-size: 15px;
    line-height: 15px;
}

.pitcher .player {
    margin: 0 0 0;
}

.pitcher .player .no {
    margin-right: 10px;
}

.Classification {
    padding-bottom: 10px;
}

.team {
    padding-bottom: 10px;
}

.info {
    font-size: 12px;
    border-collapse: separate;
    border-spacing: 5px;
    width: 100%;
    padding-left: 10px;
}

.info p {
    font-size: 12px;
    line-height: 12px;
}

.info p.team {
    transform: scale(0.8, 1);
    transform-origin: left center;
    width: 125%;
}

.info .item {
    width: 45%;
}

.info .value {
    width: 65%;
}

.info .player {
    margin-top: 6px;
}

.triangle {
    float: right;
    width: 25px;
    height: 25px;
    padding: 2px 10px 2px 0;
    text-align: center;
    line-height: 20px;
    font-size: 20px;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

/* 比較モードに追加 */
.addCompare {
    width: 250px;
    background: rgba(68, 68, 68, 0.85);
    color: #fff;
    position: absolute;
    right: 0px;
    margin-top: 10px;
}

.compareText {
    height: 30px;
    font-size: 12px;
    line-height: 27px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.compareText .icon-check {
    font-size: 20px;
    position: relative;
    bottom: 2px;
    padding-right: 5px;
}

.compareText span {
    vertical-align: middle;
}

.infoWrapper {
    transition: 0.3s;
    max-height: 525px;
    margin-bottom: 20px;
}

.ballColor {
    width: 25px;
    height: 25px;
    float: left;
}

/* 基準球検索 */
.openSearchBtn {
    width: 25px;
    height: 25px;
    float: left;
    margin: 0 10px;
    cursor: pointer;
}

.openSearchBtn .icon-search {
    font-size: 25px;
}

.attention .openSearchBtn {
    left: inherit;
    bottom: 26px;
    right: 20px;
}

/* 表示切替 */
.view {
    width: 25px;
    height: 25px;
    padding: 2px 5px;
    float: left;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.view.enable .icon-view {
    font-size: 20px;
    color: rgba(255, 255, 255, 1);
}

.view.disable .icon-view {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.35);
}

.close {
    width: 25px;
    height: 25px;
    position: absolute;
    color: #fff;
    line-height: 25px;
    font-size: 20px;
    top: 8px;
    right: 10px;
    cursor: pointer;
}

button {
    background: #666;
    width: 50px;
    border: none;
    color: #fff;
    float: left;
    margin-right: 5px;
    height: 25px;
    outline: none;
}

.done {
    border: 1px solid #fff;
    background: #333;
}

.icon-wrapper {
    margin-top: 10px;
}

</style>
